import createPaymentScheduleSelector from './createPaymentScheduleSelector'
import { PAYMENT_SCHEDULE_TYPE } from 'constants/payment'

const getDynamicPaymentScheduleRequestInfo = createPaymentScheduleSelector(PAYMENT_SCHEDULE_TYPE.DYNAMIC)

export default getDynamicPaymentScheduleRequestInfo
